<div class="editor-container">
  <div class="NgxEditor__Wrapper">
    @if (displayToolbar) {
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"></ngx-editor-menu>
    }
    <ngx-editor [editor]="editor" [formControl]="editorControl" [placeholder]="''"></ngx-editor>
  </div>
</div>
<ng-template #customMenu>
  <app-custom-toolbar [editor]="editor" [allowPlaceholders]="allowPlaceholders"></app-custom-toolbar>
</ng-template>
